import {ButtonGroup, FormButton, FormControl} from 'platform/components';

import {useWatch} from 'react-hook-form';

import {isNilOrEmpty} from 'ramda-adjunct';

import i18n from '@dms/i18n';

import {pushGtmEvent} from 'shared/web';

import {DocumentExtractionImportFormDefinition} from '../types/DocumentExtractionImportFormDefinition';

interface DocumentExtractionImportFooterActionsProps {
  control: FormControl<DocumentExtractionImportFormDefinition>;
  onClose: VoidFunction;
}

export function DocumentExtractionImportFooterActions(
  props: DocumentExtractionImportFooterActionsProps
) {
  const filesToImport = useWatch({control: props.control, name: 'filesToImport'});
  const hasUploadingFiles = filesToImport?.some((file) => file.status === 'pending');

  const handleDiscard = () => {
    pushGtmEvent({
      event: 'button_click',
      event_id: 'ai_tool_dn_import_dialog_discard',
    });
    props.onClose();
  };

  return (
    <ButtonGroup align="right">
      <FormButton
        control={props.control}
        type="button"
        variant="secondary"
        title={i18n.t('general.labels.discard')}
        onClick={handleDiscard}
      />
      <FormButton
        isDisabled={isNilOrEmpty(filesToImport) || hasUploadingFiles}
        control={props.control}
        type="submit"
        title={i18n.t('entity.documentExtraction.actions.createImportTask')}
        onClick={() =>
          pushGtmEvent({
            event: 'button_click',
            event_id: 'ai_tool_dn_import_dialog_create_import_task',
          })
        }
      />
    </ButtonGroup>
  );
}
